import firebase from 'firebase/app';
import 'firebase/auth';

export function auth (email, pw) {
  return firebase.auth().createUserWithEmailAndPassword(email, pw)
    .then(saveUser)
}

export function pad (num, size) {
  if (num === undefined) {
      return "Missing"
  }
  var s = num+"";
  while (s.length < size) s = "0" + s;
  return s;
}


export function logout () {
  return firebase.auth().signOut()
}

export function login (email, pw) {
  return firebase.auth().signInWithEmailAndPassword(email, pw)
}

export function resetPassword (email) {
  return firebase.auth().sendPasswordResetEmail(email)
}

export function saveUser (user) {
  return ref.child(`users/${user.uid}/info`)
    .set({
      email: user.email,
      uid: user.uid
    })
    .then(() => user)
}

export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}